import { Navigate, Outlet } from 'react-router-dom';
import { isUserAuthenticated } from 'utils/auth';

const PublicRoute = () => {
  const auth = isUserAuthenticated();
  return auth ? <Navigate to='/' /> : <Outlet />;
};

export default PublicRoute;
